import { openBlock, createElementBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
    createElementVNode("circle", {
      cx: "9",
      cy: "9",
      r: "7.5",
      fill: "#17B26A",
      stroke: "#fff",
      "stroke-width": "1.5"
    }, null, -1)
  ])]);
}
const OnlineIcon = { render };
export {
  OnlineIcon as default,
  render
};
//# sourceMappingURL=online.svg.js.map
